"use strict";

var _exportNames = {
  KameleoonClient: !0
};
var _javascriptSdkCore = require("@kameleoon/javascript-sdk-core");
var _kameleoonClient = require("./kameleoonClient");
Object.defineProperty(exports, "__esModule", {
  value: !0
});
Object.defineProperty(exports, "KameleoonClient", {
  enumerable: !0,
  get: function get() {
    return _kameleoonClient.KameleoonClient;
  }
});
Object.keys(_javascriptSdkCore).forEach(function (a) {
  "default" === a || "__esModule" === a || Object.prototype.hasOwnProperty.call(_exportNames, a) || a in exports && exports[a] === _javascriptSdkCore[a] || Object.defineProperty(exports, a, {
    enumerable: !0,
    get: function get() {
      return _javascriptSdkCore[a];
    }
  });
});